import { Injectable } from '@angular/core';
import { RateApp } from 'capacitor-rate-app';

@Injectable({
  providedIn: 'root',
})
export class AppRatingService {
  showPrompt = true;

  rateApp() {
    if (this.showPrompt && this.getAttempts()) {
      RateApp.requestReview();
      this.setAttempts();
    }
    this.showPrompt = false;
  }

  setAttempts() {
    const attempt: number = Number(localStorage.getItem('attempt')) || 0;
    localStorage.setItem('attempt', String(attempt + 1));
  }

  getAttempts() {
    return Number(localStorage.getItem('attempt')) < 3;
  }
}
